// extracted by mini-css-extract-plugin
export default {"editBtn":"CoveragePreferences_editBtn__RhcN8","coveragePrefHead":"CoveragePreferences_coveragePrefHead__HxvLt"};